const cards = [
  {
    title: '某女星深夜发文暗示婚变，粉丝炸锅',
    category: '明星八卦',
    desc: '一条意味深长的深夜动态，让无数粉丝彻夜难眠。知情人士透露更多细节，婚姻状况早有端倪。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20ambient%20evening%20scene%20with%20soft%20lighting%2C%20elegant%20minimalist%20interior%2C%20subtle%20dramatic%20mood%2C%20editorial%20photography%20style%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-1-c1&orientation=landscape',
    time: '2小时前',
    hot: true,
  },
  {
    title: '热门剧集大结局收视率创三年新高',
    category: '影视综艺',
    desc: '现象级剧集完美收官，最后十分钟的剧情反转让全网沸腾。制作方宣布将推出番外篇。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20golden%20spotlight%20on%20stage%2C%20warm%20theater%20atmosphere%2C%20dramatic%20lighting%2C%20elegant%20curtains%2C%20editorial%20photography%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-2-c2&orientation=landscape',
    time: '5小时前',
    hot: true,
  },
  {
    title: '两大品牌同日官宣新代言人，暗中较劲',
    category: '商业动态',
    desc: '竞品品牌选在同一天发布代言消息，人选对比引发网友热议，背后商业博弈暗流涌动。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20with%20warm%20coral%20background%2C%20minimalist%20luxury%20vibe%2C%20soft%20gradient%20lighting%2C%20editorial%20commercial%20style%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-3-c3&orientation=landscape',
    time: '8小时前',
    hot: false,
  },
  {
    title: '知名音乐人新专辑预告片暗藏玄机',
    category: '音乐动态',
    desc: '短短30秒的预告藏了五个彩蛋，歌迷逐帧分析发现重大线索，新专辑概念浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20visualization%20with%20warm%20amber%20and%20coral%20tones%2C%20sound%20wave%20patterns%2C%20artistic%20minimalist%20design%2C%20editorial%20style%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-4-c4&orientation=landscape',
    time: '12小时前',
    hot: false,
  },
  {
    title: '综艺录制意外曝光：嘉宾真实关系全揭秘',
    category: '综艺揭秘',
    desc: '节目组工作人员匿名投稿，揭开幕后真实互动。镜头前亲密无间的好友，私下关系竟如此微妙。',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20studio%20with%20warm%20lighting%2C%20camera%20equipment%2C%20dramatic%20shadows%2C%20editorial%20documentary%20style%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-5-c5&orientation=landscape',
    time: '昨天',
    hot: true,
  },
  {
    title: '下半年最值得期待的十部影视作品前瞻',
    category: '行业前瞻',
    desc: '资深影评人独家梳理下半年重磅片单，从制作班底到题材类型全面解析，收藏这篇就够了。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20projector%20with%20warm%20golden%20light%2C%20vintage%20movie%20theater%20atmosphere%2C%20editorial%20photography%2C%20no%20faces%2C%20no%20text&width=400&height=280&seq=card-6-c6&orientation=landscape',
    time: '昨天',
    hot: false,
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门吃瓜
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium whitespace-nowrap">
                  {card.category}
                </span>
                {card.hot && (
                  <span className="absolute top-3 right-3 flex items-center gap-0.5 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    <i className="ri-fire-line text-[10px]"></i>热门
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <span className="text-xs text-foreground-400">{card.time}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}